<template>
    <main-content-wrapper>
        <h1 class="text-md-center">Privolitve</h1>
        <split-content text="Privolitve in načini obveščanja" />
        <empty-space />
        <v-flex xs12 class="pa-2">
            <v-checkbox
                    v-model="confirm_all_consents"
                    color="primary"
                    required
            >
                <div slot="label">
                    Strinjam se z vsemi spodaj opredeljenimi nameni obdelovanja osebnih podatkov ter kanali obveščanja.
                </div>
            </v-checkbox>
            <v-alert
                    :value="invalid_no_cond"
                    type="error"
            >
                Za nadaljevanje se je potrebno strinjati s pogoji uporabe.
            </v-alert>
            <v-checkbox
                    v-model="confirm_cond"
                    color="primary"
                    required
            >
                <div slot="label" v-if="application_type=='HN'">
                    Potrjujem, da sem prebral/a <a href="" class="terms">splošne pogoje storitve Hitri Nakup</a> ter jih razumem in se z njimi strinjam.
                </div>
                <div slot="label" v-else>
                    Potrjujem, da sem prebral/a <a target="_blank" v-on:click.stop="" href="https://www.tus.si/o-tus-klub-kartici/splosni-pogoji-tus-klub/" class="terms">splošne pogoje poslovanja</a> Tuš kluba ter jih razumem in se z njimi strinjam.
                </div>
            </v-checkbox>
        </v-flex>
        <v-btn depressed large block color="primary_action" @click="submitConsents" :loading="loading">POTRDI</v-btn>
        <v-layout justify-center row wrap>
            <v-flex xs12 sm6 class="pa-2">
                <v-btn class="consents-toggle" text @click="show_consents=!show_consents"><v-icon v-if="!show_consents">fas fa-angle-down</v-icon><v-icon v-if="show_consents">fas fa-angle-up</v-icon> Posamezne privolitve</v-btn>
                <consents v-if="show_consents" vuex_module="registration" />
            </v-flex>
            <v-flex xs12 sm6 class="pa-2">
                <v-btn class="consents-toggle" text @click="show_consents_channels=!show_consents_channels"><v-icon v-if="!show_consents_channels">fas fa-angle-down</v-icon><v-icon v-if="show_consents_channels">fas fa-angle-up</v-icon> Kanali za obveščanje</v-btn>
                <consents-channels v-if="show_consents_channels" vuex_module="registration" />
            </v-flex>
        </v-layout>
        <v-snackbar
                v-model="consentsSavedError"
                color="error"
                top
        >
            {{ consentsSavedErrorMSG }}
            <v-btn
                    text
                    @click="consentsSavedError = false"
            >
                Zapri
            </v-btn>
        </v-snackbar>
    </main-content-wrapper>
</template>

<script>
    import MainContentWrapper from "../components/MainContentWrapper";
    import Consents from "../components/Consents";
    import ConsentsChannels from "../components/ConsentsChannels";
    import utils from "../store/utils";
    import {userService} from "../services";
    import SplitContent from "../components/SplitContent";
    import EmptySpace from "../components/EmptySpace";


    export default {
        name: "GlobalConsents",
        components: {MainContentWrapper, Consents, ConsentsChannels, EmptySpace, SplitContent},
        data: vm => ({
            loading: false,
            show_consents: false,
            show_consents_channels: false,
            confirm_cond: false,
            invalid_no_cond: false,
            consentsSavedError: false,
            consentsSavedErrorMSG: undefined
        }),
        computed: {
            application_type: utils.vuexBuildSetGet(this, 'application', 'application_type'),
            confirm_all_consents: utils.vuexBuildSetGet(this, 'registration', 'confirm_all_consents', 'registration/confirmAllConsents'),
        },
        methods: {

            submitConsents(){
                this.invalid_no_cond = this.confirm_cond == false;
                if (this.invalid_no_cond == false) {
                    this.loading = true;
                    this.consentsSavedError = false;
                    const data = {
                        consents: this.$store.state.registration.consents,
                        consent_channels: this.$store.state.registration.consent_channels,
                    };
                    userService.saveConsents(data, true).then((data) => {
                        if (data.redirect) {
                            window.location.replace(data.redirect);
                        } else {
                            this.$router.push('/');
                        }
                    }, (error) => {
                        this.consentsSavedError = true;
                        this.consentsSavedErrorMSG = error.message;
                    }).finally(() => {

                    });
                }

            }
        }
    }
</script>

<style scoped>

</style>